<zef-button-progress
  [satPopoverAnchor]
  [buttonRef]="buttonRef()"
  class="__button-progress"
  [class.is-disabled]="disabled()"
  [class.has-errors]="state.errorData?.length"
  [active]="progressActiveSignal() || loading()">
  <ng-content></ng-content>
</zef-button-progress>

<sat-popover
  [autoFocus]="false"
  [verticalAlign]="'below'"
  (closed)="onPopoverClosed$.next()"
  [anchor]="popoverAnchorRef()">
  @if (tpl(); as template) {
    <ng-template
      [ngTemplateOutlet]="template"
      [ngTemplateOutletContext]="{
        data: state.errorsActive,
        instance: popoverAnchorRef().popover
      }"
    />
  }
</sat-popover>
